
export class WpProvider {
    constructor(
        public id?: number,
        public contactFirstName?: string,
        public contactLastName?: string,
        public providerAddressTypeCd?: string,
        public addrAptNum?: string,
        public addrStNum?: string,
        public addrStNumFrac?: string,
        public addrStName?: string,
        public addrLine1?: string,
        public addrCity?: string,
        public addrState?: string,
        public addrZip5?: string,
        public addrZip4?: string,
        public isProviderValid?: string,
        public keyword?: string,
        public providerName?: string,
        public addrLine2?: string,
        public contractBeginDt?: any,
        public contractEndDt?: any,
        public tin?: string,
        public counties?: any,
        public activities?: any,
        public phoneNumber?: string,
        public email?: string,
        public notes?: string,
        public recordVersion?: number,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/wp-provider.model.ts